const cupSizes = { Full: "9oz", Half: "5oz" };
export default value => cupSizes[value] || value;
